import EntityImageActions from '../../entityImage/EntityImageActions';

const MarqueImageActions = () => <EntityImageActions entityType="marque" />;

export default MarqueImageActions;
